import React from 'react';
import './section0.less';

interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => (
  <div className="topic-section-0">
    <div className="topic-section-0-left">
      <div className="topic-section-0-heading">
        <h1 className="hero-title">
          {settings?.message}
          {/*<span>{titleLines.line1}</span>*/}
          {/*{titleLines.line2 ? <span>{titleLines.line2}</span> : null}*/}
        </h1>
      </div>
    </div>
    <div className="topic-section-0-right" />
  </div>
);
export default Section0;
